module.exports = __webpack_public_path__ + "img/p4-c1-p5.0bc48337.jpg";